import createWhereFilter, { WhereInput } from './createWhereFilter';

export default function transformWhereRelationFilterInput(
  key: string,
  fieldName?: string
): WhereInput {
  return { is: createWhereFilter(key, { key: fieldName }) };
}
